import { render } from "./insuConsule.vue?vue&type=template&id=71d885b6&scoped=true"
import script from "./insuConsule.vue?vue&type=script&lang=js"
export * from "./insuConsule.vue?vue&type=script&lang=js"

import "./insuConsule.vue?vue&type=style&index=0&id=71d885b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d885b6"]])

export default __exports__